<template>
    <iframe
        v-if="gameUrl"
        :src="gameUrl"
        allow="autoplay; fullscreen"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
    ></iframe>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'flg-frame',
    props: {
        session: {
            required: true
        }
    },
    computed: {
        gameUrl() {
            return this.session && this.session.gameUrl;
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/flg/flg-frame.vue